module.exports = __webpack_public_path__ + "img/Student Information.2b938f23.svg";